"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoComplyActiveCheckType = void 0;
var GeoComplyActiveCheckType;
(function (GeoComplyActiveCheckType) {
    /// <summary>
    /// No check methods active
    /// </summary>
    GeoComplyActiveCheckType[GeoComplyActiveCheckType["None"] = 0] = "None";
    /// <summary>
    /// Login check method active
    /// </summary>
    GeoComplyActiveCheckType[GeoComplyActiveCheckType["Login"] = 1] = "Login";
    /// <summary>
    /// Interval check method active
    /// </summary>
    GeoComplyActiveCheckType[GeoComplyActiveCheckType["Interval"] = 2] = "Interval";
    /// <summary>
    /// Ip Check method active
    /// </summary>
    GeoComplyActiveCheckType[GeoComplyActiveCheckType["IP"] = 4] = "IP";
})(GeoComplyActiveCheckType = exports.GeoComplyActiveCheckType || (exports.GeoComplyActiveCheckType = {}));
